module.exports = __webpack_public_path__ + "assets/images/USDUNFIT10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDUNFIT10.png
// module id = 1466
// module chunks = 1